import { createSlice } from "@reduxjs/toolkit";
import { database } from "../../config/firebaseConfig";

const slice = createSlice({
  name: "customers",
  initialState: {
    customers: {},
  },
  reducers: {
    customersSuccess: (state, action) => {
      state.customers = action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const { customersSuccess } = slice.actions;

export const fetchCustomers = () => async (dispatch) => {
  try {
    await database.ref("customers/customers").on("value", (snapshot) => {
      dispatch(customersSuccess(snapshot.val()));
    });
  } catch (e) {
    return console.error(e);
  }
};
